var map = {
	"./actor.svg": "b4a5",
	"./custom.svg": "d3d1",
	"./domain.svg": "88a9",
	"./email.svg": "f4fe",
	"./ip.svg": "ad17",
	"./phishing.svg": "23c6",
	"./subdomain.svg": "a1a5",
	"./threat.svg": "6be1"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "7fc6";